import clsx, { ClassValue } from 'clsx';

/**
 * A utility for conditionally joining CSS class names together
 * @example cn('foo', 'bar') // => 'foo bar'
 * @example cn('foo', { bar: true }) // => 'foo bar'
 * @example cn({ 'foo-bar': true }) // => 'foo-bar'
 * @example cn({ 'foo-bar': false }) // => ''
 */
const cn = (...inputs: ClassValue[]) => {
  return clsx(inputs);
};

export default cn;
